(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.section-head, .collection-card, .collections-intro, .series-intro, .series-editorial > div, .series-editorial .editorial-copy, .series-product .product-preview, .other-series, .story-panel, .collection-head, .product-card, .detail-copy, .shoe-category-intro, .mock-category-heading';
  let observer;
  const header = document.querySelector('.store-header');
  let previousY = window.scrollY;
  let scrollFrame = 0;

  function updateScroll() {
    const y = Math.max(0, window.scrollY);
    const distance = y - previousY;
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    document.body.style.setProperty('--scroll-progress', String(Math.min(1, y / maxScroll)));

    if (Math.abs(distance) > 6) {
      const menuOpen = header?.querySelector('.menu')?.getAttribute('aria-expanded') === 'true';
      const hide = !reduceMotion.matches && distance > 0 && y > 160 && !menuOpen && !document.body.classList.contains('shoe-drawer-open') && !header?.contains(document.activeElement);
      header?.classList.toggle('is-scrolling-down', hide);
      previousY = y;
    }
    scrollFrame = 0;
  }

  window.addEventListener('scroll', function () {
    if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateScroll);
  }, { passive: true });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-scene-toggle]');
    if (!button) return;
    const frame = button.closest('.has-scene-image');
    if (!frame) return;
    const sceneVisible = frame.classList.toggle('show-scene');
    button.setAttribute('aria-pressed', String(sceneVisible));
    button.textContent = sceneVisible ? button.dataset.productLabel : button.dataset.sceneLabel;
  });

  function reveal(root) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -35px 0px' });
    }
    root.querySelectorAll(selector).forEach(function (element) {
      if (element.classList.contains('motion-reveal')) return;
      element.classList.add('motion-reveal');
      observer.observe(element);
    });
  }

  window.wudashuMotion = reveal;
  updateScroll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(document); }, { once: true });
  } else {
    reveal(document);
  }
})();
